import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

const WithdrawBidderModal = ({
  show,
  onHide,
  withdrawReason,
  setWithdrawReason,
  onSubmit,
  loading,
  error
}) => {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Withdraw Bidder</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="g-input">
          <Form.Control
            as="textarea"
            rows={3}
            value={withdrawReason}
            onChange={(e) => setWithdrawReason(e.target.value)}
            maxLength={200}
            required
            placeholder=" "
          />
          <Form.Label>Reason for withdrawal *</Form.Label>
          {error && (
            <Form.Text className="text-danger">
              {error}
            </Form.Text>
          )}
        </Form.Group>
        <div style={{
          color: '#E1142E',
          border: '1px solid #E1142E',
          borderRadius: '5px',
          margin: '5px',
          padding: '5px'
        }}>
          <strong>Note: </strong> Clicking on Submit button will select the next highest bidder for finalizing.<br />
          <div className="text-center">
            <strong>THIS ACTION CANNOT BE UNDONE.</strong>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="success"
          className="btn-add-color semiBoldToggleButton rightAlignedButton"
          onClick={onSubmit}
          disabled={loading || !withdrawReason.trim()}
        >
          Submit
        </Button>
        <Button
          className="semiBoldToggleButton cancelBtn"
          variant="outline-success"
          onClick={onHide}
        >
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default WithdrawBidderModal;